module.exports = __webpack_public_path__ + "img/passport.30ff7ae8.png";